import React from 'react'
import { hasValue } from '../../../../../utils/helpers/value'

const Context = React.createContext([])
const { Provider } = Context

export const useImperativeComponents = () => React.useContext(Context)

const ImperativeComponents = ({ children }) => {
  const components = React.useRef([])

  const getRepliesValue = React.useCallback(() => {
    const result = components.current
      .map(component => {
        return component?.getReply()
      })
      .filter(Boolean)
      .sort((a, b) => a.question.ordination - b.question.ordination)

    return result
  }, [])

  const setFocus = React.useCallback(questionId => {
    const component = components.current[questionId]
    if (!component) return
    component.setFocus()
  }, [])

  const getBlockReplies = React.useCallback(questions => {
    return questions
      .map(question => {
        const reply = components.current[question.id]?.getReply()
        if (hasValue(reply)) {
          return { ...reply, blockIndex: -1 }
        }
        return null
      })
      .filter(Boolean)
  }, [])

  return <Provider value={{ getRepliesValue, components, setFocus, getBlockReplies }}>{children}</Provider>
}

export default ImperativeComponents
